import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateEditIsSaving = mutatorAction('updateEditIsSaving', function (isSaving) {
    var store = connectedAccountsStore();
    store.editAccountState.isSaving = isSaving;
});
//# sourceMappingURL=updateEditIsSaving.js.map